(function () {
    'use strict';

    angular
        .module('app')
        .controller('GiftCardController', GiftCardController);

        GiftCardController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies'];

    function GiftCardController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;

        function init() {
            getGiftCard();
        }

        function getGiftCard() {
            return $http.get('/app/api/gift_card/' + $stateParams.code, {code: $stateParams.code})
                .then(function (response) {
                    vm.giftCardAmount = response.data.amount / 100;
                    vm.giftCardCode = response.data.code;
                    vm.giftCardExpirationDate = response.data.expiration_date;
                    vm.giftCardCurrency = response.data.currency;
                });
        }

        function close() {
            if ($rootScope.previousState && typeof $rootScope.previousState.name == 'string') {
                // if the previous state has been set in $transitions hook
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                return $state.go('frontpage');
            }
        }

    }
})();